/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DashboardControllerDtoGetDashboardDataMiningStatistics from './DashboardControllerDtoGetDashboardDataMiningStatistics';
import DashboardControllerDtoGetDashboardDataTransactionStatistics from './DashboardControllerDtoGetDashboardDataTransactionStatistics';
import DashboardControllerDtoGetDashboardDataUserStatistics from './DashboardControllerDtoGetDashboardDataUserStatistics';
import DashboardControllerDtoGetDashboardDataWalletData from './DashboardControllerDtoGetDashboardDataWalletData';
import MaterialProperty from './MaterialProperty';

/**
 * The DashboardControllerDtoGetDashboardDataResponse model module.
 * @module model/DashboardControllerDtoGetDashboardDataResponse
 * @version 1.0
 */
class DashboardControllerDtoGetDashboardDataResponse {
    /**
     * Constructs a new <code>DashboardControllerDtoGetDashboardDataResponse</code>.
     * @alias module:model/DashboardControllerDtoGetDashboardDataResponse
     */
    constructor() { 
        
        DashboardControllerDtoGetDashboardDataResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DashboardControllerDtoGetDashboardDataResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DashboardControllerDtoGetDashboardDataResponse} obj Optional instance to populate.
     * @return {module:model/DashboardControllerDtoGetDashboardDataResponse} The populated <code>DashboardControllerDtoGetDashboardDataResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DashboardControllerDtoGetDashboardDataResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('userStatistics')) {
                obj['userStatistics'] = ApiClient.convertToType(data['userStatistics'], [DashboardControllerDtoGetDashboardDataUserStatistics]);
            }
            if (data.hasOwnProperty('miningStatistics')) {
                obj['miningStatistics'] = ApiClient.convertToType(data['miningStatistics'], [DashboardControllerDtoGetDashboardDataMiningStatistics]);
            }
            if (data.hasOwnProperty('transactionStatistics')) {
                obj['transactionStatistics'] = ApiClient.convertToType(data['transactionStatistics'], [DashboardControllerDtoGetDashboardDataTransactionStatistics]);
            }
            if (data.hasOwnProperty('assetsStatistics')) {
                obj['assetsStatistics'] = ApiClient.convertToType(data['assetsStatistics'], {'String': [DashboardControllerDtoGetDashboardDataWalletData]});
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>DashboardControllerDtoGetDashboardDataResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>DashboardControllerDtoGetDashboardDataResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        if (data['userStatistics']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['userStatistics'])) {
                throw new Error("Expected the field `userStatistics` to be an array in the JSON data but got " + data['userStatistics']);
            }
            // validate the optional field `userStatistics` (array)
            for (const item of data['userStatistics']) {
                DashboardControllerDtoGetDashboardDataUserStatistics.validateJSON(item);
            };
        }
        if (data['miningStatistics']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['miningStatistics'])) {
                throw new Error("Expected the field `miningStatistics` to be an array in the JSON data but got " + data['miningStatistics']);
            }
            // validate the optional field `miningStatistics` (array)
            for (const item of data['miningStatistics']) {
                DashboardControllerDtoGetDashboardDataMiningStatistics.validateJSON(item);
            };
        }
        if (data['transactionStatistics']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['transactionStatistics'])) {
                throw new Error("Expected the field `transactionStatistics` to be an array in the JSON data but got " + data['transactionStatistics']);
            }
            // validate the optional field `transactionStatistics` (array)
            for (const item of data['transactionStatistics']) {
                DashboardControllerDtoGetDashboardDataTransactionStatistics.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Array.<module:model/DashboardControllerDtoGetDashboardDataUserStatistics>} userStatistics
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['userStatistics'] = undefined;

/**
 * @member {Array.<module:model/DashboardControllerDtoGetDashboardDataMiningStatistics>} miningStatistics
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['miningStatistics'] = undefined;

/**
 * @member {Array.<module:model/DashboardControllerDtoGetDashboardDataTransactionStatistics>} transactionStatistics
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['transactionStatistics'] = undefined;

/**
 * @member {Object.<String, Array.<module:model/DashboardControllerDtoGetDashboardDataWalletData>>} assetsStatistics
 */
DashboardControllerDtoGetDashboardDataResponse.prototype['assetsStatistics'] = undefined;






export default DashboardControllerDtoGetDashboardDataResponse;

